export const locale = {
    id: 'cs-CZ',
    prefix: '',
    mailDomain: 'cz',
};
